var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:'infration-item' + _vm.item.id,staticClass:"infraction-item"},[_c('h5',{staticClass:"infraction-item-title text-white"},[_vm._v("\n    "+_vm._s(_vm.item.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }